import { lazyPage } from "@core/app/lazyPage";
import type { WebModule } from "@modules/registry";

const CartPage = lazyPage(() => import("./pages/CartPage"), "CartPage");

export const cartModule: WebModule = {
  id: "cart",
  nav: null,
  routes: [{ path: "/cart", element: <CartPage /> }],
  publicRoutes: [],
};
